import { NgModule } from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import {MatSidenavModule} from "@angular/material/sidenav";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatListModule} from "@angular/material/list";
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import {MatDialogModule} from "@angular/material/dialog";
import { RegisterComponent } from './components/register/register.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AdminDashboardComponent } from './components/admin/admin-dashboard/admin-dashboard.component';
import { WildcardErrorPageComponent } from './components/wildcard-error-page/wildcard-error-page.component';
import { AdminWrapperComponent } from './components/admin/admin-wrapper/admin-wrapper.component';
import { UserWrapperComponent } from './components/user-wrapper/user-wrapper.component';
import { UnauthorizedUserComponent } from './components/unauthorized-user/unauthorized-user.component';
import {MatCardModule} from "@angular/material/card";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import { UserSearchComponent } from './components/admin/user-search/user-search.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {UserExistDirective} from './directives/user-exist.directive';
import { EmailExistDirective } from './directives/email-exist.directive';
import {MatSelectModule} from "@angular/material/select";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatSortModule} from "@angular/material/sort";
import { LandingComponent } from './components/landing/landing.component';
import {HttpErrorInterceptor, WithCredentialsInterceptor} from "./services/http.service";
import {A11yModule} from "@angular/cdk/a11y";
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { SysNoteComponent } from './components/admin/sys-note/sys-note.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import { PaginationSaveDirective } from './directives/pagination-save.directive';
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {TruncatePipe} from "./services/truncate.pipe";
import { DashboardTreeComponent } from './components/dashboard-tree/dashboard-tree.component';
import { CaseDocketsheetComponent } from './components/case-docketsheet/case-docketsheet.component';
import {MatRadioModule} from "@angular/material/radio";
import { AdvancedSearchComponent } from './components/advanced-search/advanced-search.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import { AgencySelectionComponent } from './components/agency-selection/agency-selection.component';
import {RemoveCaseComponent} from "./components/admin/remove-case/remove-case.component";
import {ManageGaoUsersComponent} from "./components/admin/manage-gao-users/manage-gao-users.component";
import {AddOrEditGaoUserComponent} from "./components/admin/manage-gao-users/add-or-edit-gao-user/add-or-edit-gao-user.component";
import {ManageProfileComponent} from "./components/manage-profile/manage-profile.component";
import {ProtestPageComponent} from "./components/protest-page/protest-page.component";
import {MatProgressBar} from "@angular/material/progress-bar";
import {FileUploadComponent} from "./components/file-upload/file-upload.component";
import {ManageAgencyContactsComponent} from "./components/admin/manage-agency-contacts/manage-agency-contacts.component";
import {AddOrEditAgencyContactComponent} from "./components/admin/manage-agency-contacts/add-or-edit-agency-contact/add-or-edit-agency-contact.component";
import {EditTemplatesComponent} from "./components/admin/edit-templates/edit-templates.component";
import {CKEditorModule} from "@ckeditor/ckeditor5-angular";
import {SelectAllDirective} from "./directives/select-all.directive";
import {EditControlsComponent} from "./components/edit-controls/edit-controls.component";
import {JoinUnjoinCasesComponent} from "./components/admin/join-unjoin-cases/join-unjoin-cases.component";
import {PartiesComponent} from "./components/parties/parties.component";
import {PartiesInfoComponent} from "./components/parties/parties-info/parties-info.component";
import { ValidatePasswordDirective } from './directives/validate-password.directive';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { MatchPasswordDirective } from './directives/match-password.directive';
import { ValidateNewPasswordDirective } from './directives/validate-new-password.directive';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ChangeSecurityQuestionsComponent } from './components/change-security-questions/change-security-questions.component';
import { ChangeUserNameComponent } from './components/change-username/change-username.component';
import {SecurityQuestionComponent} from "./components/security-questions/security-questions.component";
import {PaymentStatusComponent} from "./components/payment-status/payment-status.component";
import {SpinnerDirective} from "./directives/spinner.directive";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import { UserInvitationsComponent } from './components/dashboard/user-invitations/user-invitations.component';
import {NgIdleKeepaliveModule} from "@ng-idle/keepalive";
import {SubmitNewDocumentsComponent} from "./components/submit-new-documents/submit-new-documents.component";
import {OtherProtestComponent} from "./components/other-protest/other-protest.component";
import {JoinRequestComponent} from "./components/join-request/join-request.component";
import {AddIntervenorComponent} from "./components/parties/add-intervenor/add-intervenor.component";
import {AddAgencyRepComponent} from "./components/join-request/add-agency-rep/add-agency-rep.component";
import { DocketDocumentViewComponent } from './components/docket-document-view/docket-document-view.component';
import { DatePipe } from '@angular/common';
import { ReplaceDocumentComponent } from './components/docket-document-view/replace-document/replace-document.components';
import { DenialOfDocumentComponent } from './components/docket-document-view/denial-of-document/denial-of-document.component';
import {GmapAutocomDirective} from "./directives/gmap-autocom.directive";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    CustomModalComponent,
    RegisterComponent,
    DashboardComponent,
    AdminDashboardComponent,
    WildcardErrorPageComponent,
    AdminWrapperComponent,
    UserWrapperComponent,
    UnauthorizedUserComponent,
    UserSearchComponent,
    UserExistDirective,
    EmailExistDirective,
    LandingComponent,
    AutoFocusDirective,
    SysNoteComponent,
    PaginationSaveDirective,
    TruncatePipe,
    DashboardTreeComponent,
    CaseDocketsheetComponent,
    AdvancedSearchComponent,
    RemoveCaseComponent,
    ManageGaoUsersComponent,
    AddOrEditGaoUserComponent,
    ManageProfileComponent,
    ProtestPageComponent,
    SubmitNewDocumentsComponent,
    FileUploadComponent,
    AgencySelectionComponent,
    ManageAgencyContactsComponent,
    AddOrEditAgencyContactComponent,
    EditTemplatesComponent,
    EditControlsComponent,
    JoinUnjoinCasesComponent,
    PartiesComponent,
    PartiesInfoComponent,
    JoinUnjoinCasesComponent,
    EditTemplatesComponent,
    ValidatePasswordDirective,
    ChangePasswordComponent,
    MatchPasswordDirective,
    ValidateNewPasswordDirective,
    ForgotPasswordComponent,
    ChangeSecurityQuestionsComponent,
    ChangeUserNameComponent,
    SecurityQuestionComponent,
    EditTemplatesComponent,
    PaymentStatusComponent,
    SpinnerDirective,
    UserInvitationsComponent,
    OtherProtestComponent,
    JoinRequestComponent,
    AddIntervenorComponent,
    AddAgencyRepComponent,
    DocketDocumentViewComponent,
    ReplaceDocumentComponent,
    DenialOfDocumentComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    FlexLayoutModule,
    MatListModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    A11yModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatTooltipModule,
    CKEditorModule,
    SelectAllDirective,
    MatProgressBar,
    MatProgressSpinner,
    NgIdleKeepaliveModule.forRoot(),
    GmapAutocomDirective,
    ReactiveFormsModule
  ],
  providers: [
    DatePipe,
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WithCredentialsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
